module.exports = __webpack_public_path__ + "assets/ic_cart_minus-9e1788.svg";